import React from 'react';
import classNames from 'classnames';
import {Field, change, touch} from 'redux-form';
import {Button, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import {isEmpty} from '../validation';

/*
 * Creates an input component
 * Use for string, email, phone, password, etc...
*/
export class Input extends React.Component {
    constructor(props) {
        super(props);
        const {defaultValue, input} = props;
        if (!isEmpty(defaultValue)) {
            input.onChange(defaultValue);
        }
        this.onChange = this.onChange.bind(this);
    }

    onChange(eventOrValue) {
        const {input, onChangeComplete} = this.props;
        input.onChange(eventOrValue);
        if (onChangeComplete) {
            onChangeComplete(eventOrValue);
        }
    }

    render () {
        const {
            handlechange,
            value,
            input,
            label,
            type,
            required,
            placeholder,
            fieldInstruction,
            showAsterisk = true,
            hideLabel = false,
            hideFeedback = false,
            hidden = false,
            meta: { error, warning, touched },
            ...props
        } = this.props;
        delete props.defaultValue;
        delete props.initialValues;

        let message;
        const validationState = touched && ( error && 'error' ) || ( warning && 'warning' ) || null;

        if ( touched && ( error || warning ) ) {
            message = <span className="help-block">{ error || warning }</span>;
        }

        let placeholderText = label;
        if ( placeholder !== undefined ) {
            placeholderText = placeholder;
        }

        const asterisk = showAsterisk && required && (<span className="form-field-required" />) || null;

        return (
            <FormGroup className={classNames({hidden})} validationState={ validationState }>
                {
                    !hideLabel && (
                        <ControlLabel>
                            { label }
                            { asterisk }
                            {fieldInstruction}
                        </ControlLabel>
                    )
                }
                <FormControl {...{
                    ...input,
                    type,
                    placeholder: placeholderText,
                    ...props
                }} onChange={handlechange}
                 value={value} />
                { message }
                {!hideFeedback && <FormControl.Feedback />}
            </FormGroup>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    change: (formName, fieldName, value) => dispatch(change(formName, fieldName, value)),
    touch: (formName, ...fields) => dispatch(touch(formName, ...fields)),
});

/**
 * Creates a TextArea component
 * Use for notes, description, or general long text inputs
 */
export class TextArea extends React.Component {
    constructor(props) {
        super(props);
        const {defaultValue, input} = props;
        if (!isEmpty(defaultValue) && isEmpty(input.value)) {
            input.onChange(defaultValue);
        }
        this.onChange = this.onChange.bind(this);
    }

    onChange(eventOrValue) {
        const {input, onChangeComplete} = this.props;
        input.onChange(eventOrValue);
        if (onChangeComplete) {
            onChangeComplete(eventOrValue);
        }
    }

    render () {
        const {
            input,
            label,
            placeholder,
            required,
            hideLabel = false,
            hideFeedback = false,
            readOnly,
            row,
            meta: { error, warning, touched },
        } = this.props;

        let message;
        const validationState = touched && ( error && 'error' ) || ( warning && 'warning' ) || null;

        if ( touched && ( error || warning ) ) {
            message = <span className="help-block">{ error || warning }</span>;
        }

        let placeholderText = label;
        if ( placeholder ) {
            placeholderText = placeholder;
        }

        const asterisk = required && (<span className="form-field-required" />) || null;

        return (
            <FormGroup validationState={ validationState }>
                {!hideLabel && (
                    <ControlLabel>
                        { label }
                        { asterisk }
                    </ControlLabel>
                )}
                <FormControl {...{
                    ref: ref => this.ref = ref,
                    ...input,
                    onChange: this.onChange,
                    componentClass: 'textarea',
                    rows: row || '4',
                    placeholder: placeholderText,
                    readOnly,
                }} />
                { message }
                {!hideFeedback && <FormControl.Feedback />}
            </FormGroup>
        );
    }
}

/**
 * Single select dropdown component
 * - Uses an array passed to options prop
 * - 'options' Array must have 'value' (what is submitted) & 'text' (what is displayed)
 */
export class SingleSelect extends React.Component {
    render () {
        const {
            input,
            label,
            options,
            required,
            placeholder,
            meta: { error, warning, touched },
            ...props
        } = this.props;

        let message;
        const validationState = touched && ( error && 'error' ) || ( warning && 'warning' ) || null;

        if ( touched && ( error || warning ) ) {
            message = <span className="help-block">{ error || warning }</span>;
        }

        let placeholderText = 'Select an option';
        if ( placeholder ) {
            placeholderText = placeholder;
        }

        const asterisk = required && (<span className="form-field-required" />) || null;

        return (
            <FormGroup validationState={ validationState }>
                <ControlLabel>
                    { label }
                    { asterisk }
                </ControlLabel>

                <FormControl {...{
                    ...input,
                    componentClass: 'select',
                    placeholder: placeholderText,
                    ...props
                }} >
                    <option value="">{ placeholderText }</option>
                    {
                        options.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.text}
                            </option>
                        ))
                    }
                </FormControl>
                { message }
                <FormControl.Feedback />
            </FormGroup>
        );
    }
}

const ListItem = ({ item }) => (
    <span>
    {item.name}
        {
            item.type && (
                <span className="label label-primary pull-right rot-complete-label">{item.type}</span>
            )
        }
  </span>
);

/**
 * Creates an FieldWrapper component
 */
export const withFieldWrapper = (Component) => (
    class FieldWrapper extends React.Component {
        render () {
            const {label, required} = this.props;
            const asterisk = required && (<span className="form-field-required" />) || null;

            return (
                <FormGroup>
                    <ControlLabel>
                        { label }
                        { asterisk }
                    </ControlLabel>
                    <Component className="form-control" />
                </FormGroup>
            );
        }
    }
);



// WEBPACK FOOTER //
// ./src/js/utilities/form/fields.js